export enum ICON{
    info,
    warning,
		edit,
    question,
    fail,
    success,
    delete,
    nothing
  }